import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49332094"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "air" }
const _hoisted_2 = { class: "air-top" }
const _hoisted_3 = { class: "air-desc" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "air-title" }, "空调", -1))
const _hoisted_5 = { class: "air-temperature" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "℃", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "air-right" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "air-control air-control-padding" }
const _hoisted_12 = { class: "control-box" }
const _hoisted_13 = { class: "temp-text" }
const _hoisted_14 = {
  class: "temp-slider",
  id: "sliderId"
}
const _hoisted_15 = {
  class: "slider-bar",
  id: "barId"
}
const _hoisted_16 = { class: "bar-temp" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bar-circle",
  id: "handId"
}, null, -1))
const _hoisted_18 = { class: "temp-text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control-text" }, "温度设定", -1))
const _hoisted_20 = { class: "air-control" }
const _hoisted_21 = { class: "control-box" }
const _hoisted_22 = { class: "volume-box" }
const _hoisted_23 = { class: "number" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "风量调节", -1))
const _hoisted_25 = { class: "volume-icon" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " AUTO", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "air-control" }
const _hoisted_31 = { class: "control-box" }
const _hoisted_32 = { class: "volume-box" }
const _hoisted_33 = { class: "model" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "模式设定", -1))
const _hoisted_35 = { class: "volume-icon" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "air-child"
}
const _hoisted_40 = { class: "open-title" }
const _hoisted_41 = { class: "adjust-item" }
const _hoisted_42 = { class: "adjust-text" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "adjust-title" }, "温度", -1))
const _hoisted_44 = { class: "adjust-item" }
const _hoisted_45 = { class: "adjust-text" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "adjust-title" }, "档位", -1))
const _hoisted_47 = { class: "adjust-item" }
const _hoisted_48 = { class: "adjust-text" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "adjust-title" }, "模式", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.airTemp ? _ctx.airTemp : "--") + " ", 1),
          _hoisted_6
        ]),
        (_ctx.equipList && _ctx.equipList.length > 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "show-all",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)), ["stop"]))
            }, [
              _createVNode(_component_van_icon, {
                name: _ctx.lightIcon,
                class: "light-icon"
              }, null, 8, ["name"]),
              (!_ctx.showChild)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "查看全部"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "收起全部"))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.airData.airImg)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.airData.airImg,
              alt: ""
            }, null, 8, _hoisted_10))
          : (_openBlock(), _createBlock(_component_van_loading, {
              key: 1,
              style: {"padding-top":"20px"}
            })),
        (!_ctx.showChild)
          ? (_openBlock(), _createBlock(_component_Switch, {
              key: 2,
              class: "switch-btn",
              loading: _ctx.loadingAir || _ctx.firstLoadingAir,
              disabled: _ctx.loadingAir || _ctx.firstLoadingAir,
              "inactive-color": "rgba(196, 196, 196, 0.4)",
              onClick: _ctx.airChange,
              "model-value": _ctx.airData.isOpen
            }, null, 8, ["loading", "disabled", "onClick", "model-value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.showChild && _ctx.airData.runStatus)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({ opacity: _ctx.loadingAir || !_ctx.airData.runStatus ? '0.4' : '1' })
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.airData.minTempSet) + "℃", 1),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
                  return _createElementVNode("div", {
                    class: "item",
                    key: 'bar' + index
                  })
                }), 64)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.realTemp) + "℃", 1),
                  _hoisted_17
                ])
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.airData.maxTempSet) + "℃", 1)
            ]),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windGearArr, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(_ctx.airData.gear === item ? 'number-active' : ''),
                      key: 'volume' + index
                    }, _toDisplayString(item), 3))
                  }), 128))
                ]),
                _hoisted_24
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: "icon-item",
                  style: _normalizeStyle({
                opacity: _ctx.airData.gear <= 1 ? '0.6' : 1,
              }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeZongAir('gear', 'windLow')))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.parseImgUrl('ipdImages', 'wind_small.png')
                  }, null, 8, _hoisted_26)
                ], 4),
                _createElementVNode("div", {
                  class: "icon-item",
                  style: _normalizeStyle({ opacity: _ctx.airData.gear >= 3 ? '0.6' : 1 }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeZongAir('gear', 'windUp')))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.parseImgUrl('ipdImages', 'wind_big.png')
                  }, null, 8, _hoisted_27)
                ], 4),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-item", _ctx.airData.isAutoGear ? 'active-color' : '']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeZongAir('gear', 'auto')))
                }, _hoisted_29, 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.airData.workMode == 1
                  ? "制冷"
                  : _ctx.airData.workMode == 2
                  ? "制热"
                  : "通风"), 1),
                _hoisted_34
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-item", _ctx.airData.workMode === 2 ? 'active-color' : '']),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeZongAir('mode', 2)))
                }, [
                  _createElementVNode("img", {
                    src: 
                  _ctx.airData.workMode === 2
                    ? _ctx.parseImgUrl('ipdImages', 'airsunred.svg')
                    : _ctx.parseImgUrl('ipdImages', 'airsunblack.svg')
                
                  }, null, 8, _hoisted_36)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-item", _ctx.airData.workMode === 1 ? 'active-color' : '']),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeZongAir('mode', 1)))
                }, [
                  _createElementVNode("img", {
                    src: 
                  _ctx.airData.workMode === 1
                    ? _ctx.parseImgUrl('ipdImages', 'aircoldblue.svg')
                    : _ctx.parseImgUrl('ipdImages', 'aircoldblack.svg')
                
                  }, null, 8, _hoisted_37)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-item", _ctx.airData.workMode === 3 ? 'active-color' : '']),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeZongAir('mode', 3)))
                }, [
                  _createElementVNode("img", {
                    src: 
                  _ctx.airData.workMode === 3
                    ? _ctx.parseImgUrl('ipdImages', 'aircloudgreen.svg')
                    : _ctx.parseImgUrl('ipdImages', 'aircloudblack.svg')
                
                  }, null, 8, _hoisted_38)
                ], 2)
              ])
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.showChild)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipList, (childItem, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "child-control-box",
              key: 'child' + index
            }, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", null, _toDisplayString(childItem.localName), 1),
                _createVNode(_component_Switch, {
                  onClick: ($event: any) => (_ctx.changeChildItemAir('switch', childItem, 'switch')),
                  loading: 
              childItem.loadingTimer > 0 && childItem.loadingTimer <= 15
                ? true
                : false
            ,
                  disabled: 
              childItem.loadingTimer > 0 && childItem.loadingTimer <= 15
                ? true
                : false
            ,
                  "model-value": childItem.isOpen,
                  class: "child-switch",
                  "inactive-color": "rgba(196, 196, 196, 0.4)",
                  size: "14px"
                }, null, 8, ["onClick", "loading", "disabled", "model-value"])
              ]),
              _createElementVNode("div", {
                class: "adjust-box",
                style: _normalizeStyle({
            opacity: childItem.runStatus && childItem.isOpen ? '' : '0.3',
          })
              }, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_van_icon, {
                    name: "arrow-up",
                    class: _normalizeClass([
                childItem.tempSet >= _ctx.airData.maxTempSet ? 'disable-color' : ''
              , "adjust-icon"]),
                    onClick: ($event: any) => (_ctx.changeChildItemAir('temp', childItem, 'up'))
                  }, null, 8, ["class", "onClick"]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", {
                      class: "value-wrap",
                      style: _normalizeStyle({
                  transform: _ctx.valueHeight
                    ? 'translateY(' + -childItem.sel * _ctx.valueHeight + 'px)'
                    : 'translateY(0px)',
                })
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childItem.tempArr, (titem, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "value",
                          key: index + 'ct'
                        }, _toDisplayString(titem), 1))
                      }), 128))
                    ], 4)
                  ]),
                  _createVNode(_component_van_icon, {
                    name: "arrow-down",
                    class: _normalizeClass([
                childItem.tempSet <= _ctx.airData.minTempSet ? 'disable-color' : ''
              , "adjust-icon"]),
                    onClick: ($event: any) => (_ctx.changeChildItemAir('temp', childItem, 'down'))
                  }, null, 8, ["class", "onClick"]),
                  _hoisted_43
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_van_icon, {
                    name: "arrow-up",
                    class: _normalizeClass([childItem.isAutoGear ? 'disable-color' : '', "adjust-icon"]),
                    onClick: ($event: any) => (_ctx.changeChildItemAir('gear', childItem, 'up'))
                  }, null, 8, ["class", "onClick"]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", {
                      class: "value-wrap",
                      style: _normalizeStyle({
                  transform: _ctx.valueHeight
                    ? 'translateY(' + -childItem.gIndex * _ctx.valueHeight + 'px)'
                    : 'translateY(0px)',
                })
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childItem.gearArr, (gItem, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "value",
                          key: index + 'g'
                        }, _toDisplayString(gItem), 1))
                      }), 128))
                    ], 4)
                  ]),
                  _createVNode(_component_van_icon, {
                    name: "arrow-down",
                    class: _normalizeClass([
                !childItem.isAutoGear && childItem.gear <= 1
                  ? 'disable-color'
                  : ''
              , "adjust-icon"]),
                    onClick: ($event: any) => (_ctx.changeChildItemAir('gear', childItem, 'down'))
                  }, null, 8, ["class", "onClick"]),
                  _hoisted_46
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_van_icon, {
                    name: "arrow-up",
                    class: _normalizeClass([childItem.workMode >= 3 ? 'disable-color' : '', "adjust-icon"]),
                    onClick: ($event: any) => (_ctx.changeChildItemAir('model', childItem, 'up'))
                  }, null, 8, ["class", "onClick"]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", {
                      class: "value-wrap",
                      style: _normalizeStyle({
                  transform: _ctx.valueHeight
                    ? 'translateY(' + -childItem.mIndex * _ctx.valueHeight + 'px)'
                    : 'translateY(0px)',
                })
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childItem.modelArr, (mItem, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "value",
                          key: index + 'm'
                        }, _toDisplayString(mItem), 1))
                      }), 128))
                    ], 4)
                  ]),
                  _createVNode(_component_van_icon, {
                    name: "arrow-down",
                    class: _normalizeClass([childItem.workMode <= 1 ? 'disable-color' : '', "adjust-icon"]),
                    onClick: ($event: any) => (_ctx.changeChildItemAir('model', childItem, 'down'))
                  }, null, 8, ["class", "onClick"]),
                  _hoisted_49
                ])
              ], 4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}